import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-outer-pages-footer',
  templateUrl: './outer-pages-footer.component.html',
  styleUrls: ['./outer-pages-footer.component.css']
})
export class OuterPagesFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
